import {useEffect, useState} from "react";
import {Specifications} from "./Specifications/Specifications";
import {Admittances} from "./Admittances/Admittances";
import {Filter} from "./Filter/Filter";
import styles from "./Filters.module.css"
import { Accordion, AccordionTab } from 'primereact/accordion';

export const Filters = ({filters, getProductsWithFilter, checkedFiltersObject, setCheckedFiltersObject}) => {
    const [productCategoryActiveIndex, setProductCategoryActiveIndex] = useState(1);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if(filters?.ProductСategories?.length > 0){
            setProductCategoryActiveIndex(0);
        }
        else {
            setProductCategoryActiveIndex(1);
        }
    }, [filters])


    return (
        <div style={{paddingRight:'5px', paddingBottom: '30px'}}>
            <Accordion activeIndex={0} className={styles.accordion}>
                <AccordionTab header={
                    <div className="flex align-items-center">
                        <i className={ "pi pi-folder mr-2"}></i>
                        <span className="vertical-align-middle"> Категорія товару</span>
                    </div>
                }>
                    <Filter filters={filters.ProductСategories} filterType={"ProductСategories"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} />
                </AccordionTab>
            </Accordion>
            <Accordion className={styles.accordion}>
                <AccordionTab header={
                    <div className="flex align-items-center">
                        <i className={ "pi pi-folder mr-2"}></i>
                        <span className="vertical-align-middle"> Категорія техніки</span>
                    </div>
                }>
                    <Filter filters={filters.EquipmentСategories} filterType={"EquipmentСategories"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} />
                </AccordionTab>
            </Accordion>
            <Accordion className={styles.accordion}>
                <AccordionTab header={
                    <div className="flex align-items-center">
                        <i className="pi pi-folder mr-2"></i>
                        <span className="vertical-align-middle">В'язкість</span>
                    </div>
                }>
                    <Filter filters={filters.OilViscosities} filterType={"OilViscosities"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} />
                </AccordionTab>
            </Accordion>

            <Accordion className={styles.accordion}>
                <AccordionTab header={
                    <div className="flex align-items-center">
                        <i className="pi pi-folder mr-2"></i>
                        <span className="vertical-align-middle">Фасування</span>
                    </div>
                }>
                    <Filter filters={filters.ProductPackages} filterType={"ProductPackages"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} />
                </AccordionTab>
            </Accordion>

            <Accordion className={styles.accordion}>
                <AccordionTab header={
                    <div className="flex align-items-center">
                        <i className="pi pi-folder mr-2"></i>
                        <span className="vertical-align-middle">Тип оливи</span>
                    </div>
                }>
                    <Filter filters={filters.OilTypes} filterType={"OilTypes"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} />
                </AccordionTab>
            </Accordion>

            {/* Скрываем пока */}
            {/* <Accordion className={styles.accordion}>
                <AccordionTab header={
                    <div className="flex align-items-center">
                        <i className="pi pi-folder mr-2"></i>
                        <span className="vertical-align-middle">Тип двигуна</span>
                    </div>
                }>
                    <Filter filters={filters.EngineTypes} filterType={"EngineTypes"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} />
                </AccordionTab>
            </Accordion> */}

            <Accordion className={styles.accordion} >
                <AccordionTab header={
                    <div className="flex align-items-center">
                        <i className="pi pi-folder mr-2"></i>
                        <span className="vertical-align-middle">Специфікації</span>
                    </div>
                }>
                    <Specifications specList={filters.Specifications} filterType={"Specifications"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} />
                </AccordionTab>
            </Accordion>

            <Accordion className={styles.accordion}>
                <AccordionTab header={
                    <div className="flex align-items-center">
                        <i className="pi pi-folder mr-2"></i>
                        <span className="vertical-align-middle">Допуски</span>
                    </div>
                }>
                    <Admittances admittanceList={filters.Admittances} filterType={"Admittances"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} />
                </AccordionTab>
            </Accordion>





            {/* <Accordion className={styles.accordion} defaultActiveKey="OilViscosities">
                <Accordion.Header>Вязкость</Accordion.Header>
                <Accordion.Body><Filter filters={filters.OilViscosities} filterType={"OilViscosities"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} /></Accordion.Body>
            </Accordion>
            <Accordion className={styles.accordion} defaultActiveKey="OilTypes">
                <Accordion.Header>Тип масла</Accordion.Header>
                <Accordion.Body><Filter filters={filters.OilTypes} filterType={"OilTypes"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} /></Accordion.Body>
            </Accordion>
            <Accordion className={styles.accordion} defaultActiveKey="EngineTypes">
                <Accordion.Header>Тип двигателя</Accordion.Header>
                <Accordion.Body><Filter filters={filters.EngineTypes} filterType={"EngineTypes"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} /></Accordion.Body>
            </Accordion>
            <Accordion className={styles.accordion} defaultActiveKey="Specifications" >
                <Accordion.Header>Спецификации</Accordion.Header>
                <Accordion.Body><Specifications specList={filters.Specifications} filterType={"Specifications"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} /></Accordion.Body>
            </Accordion >
            <Accordion className={styles.accordion} defaultActiveKey="Admittances" >
                <Accordion.Header>Допуски</Accordion.Header>
                <Accordion.Body><Admittances admittanceList={filters.Admittances} filterType={"Admittances"} checkedFiltersObject = {checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject} /></Accordion.Body>
            </Accordion>*/}

        </div>

    )
}